import { DotsColor } from 'types';

import * as Styles from './styles';
import { DotsLoadingProps } from './types';

export const DotsLoader = ({
  style,
  size = 16,
  className,
  colorType = DotsColor.Grey,
}: DotsLoadingProps) => (
  <Styles.Loader
    size={size}
    style={style}
    className={className}
    colorType={colorType}
  >
    <div className="bounce1"></div>
    <div className="bounce2"></div>
    <div className="bounce3"></div>
  </Styles.Loader>
);
